import React, { useEffect, useState } from 'react';
import { Provider, observer } from 'mobx-react';
import { AppRouter } from '../AppRouter/AppRouter';
import AuthStore from '../../store/AuthStore';
import { useIdleTimer } from 'react-idle-timer';
import { LoadingProgress } from '../LoadingProgress';
import { CustomSnackbar } from '../CustomSnackbar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Button } from '@mui/material';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#F07B0E',
//       // light: will be calculated from palette.primary.main,
//       // dark: will be calculated from palette.primary.main,
//       // contrastText: will be calculated to contrast with palette.primary.main
//     },
//   },
// });

const themeOptions = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#F07B0E',
      contrastText: '#ffffff', // White text on primary color
    },
    secondary: {
      main: '#f50057',
    },
    ternary: {
      main: '#1976d2',
      contrastText: '#ffffff', // White text on primary color
    },
  },
});

// export const themeOptions = {
//   palette: {
//     mode: 'light',
//     primary: {
//       main: '#ff5733',
//     },
//     secondary: {
//       main: '#f50057',
//     },
//   },
// };

export const App = observer(() => {
  AuthStore.toggleIsUserAuthnticated();

  const handleOnIdle = (event) => {
    AuthStore.logout();
  };

  const handleOnActive = (event) => {
    AuthStore.setSessionExpirayIdelTimer(0);
  };

  const handleOnAction = (event) => {};

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 20,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
      'focus',
    ],
  });

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={themeOptions}>
          <Provider AuthStore={AuthStore}>
            <AppRouter />
            <LoadingProgress></LoadingProgress>
            <CustomSnackbar></CustomSnackbar>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
});
